export const GET_CHAT_CONNECTIONS="GET_CHAT_CONNECTIONS";
export const SET_AS_READ="SET_AS_READ";
export const GET_CHAT_MESSAGES="GET_CHAT_MESSAGES";
export const POST_MESSAGE="POST_MESSAGE";
export const POST_SEARCH_CONNECTION="POST_SEARCH_CONNECTION";
export const POST_SEARCH_CONSULTANTS = "POST_SEARCH_CONSULTANTS";



